import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerIsPhoneCss = "cmvelho";
const containerIsEnteringCss = "c1ljhpu";
const containerIsExitingCss = "cxm6we";
const containerCss = "cesv5au";
export const Container = forwardRef((props, ref) => {
  const {
    isEntering,
    isExiting,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone,
    [containerIsEnteringCss]: isEntering,
    [containerIsExitingCss]: isExiting
  }, props.className)} />;
});
const bodyCss = "b9jo9d4";
export const Body = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bodyCss, props.className)} />;
});
const wrapperIsSelectedSectionCss = "wl2cumy";
const wrapperCss = "w15v7fpi";
export const Wrapper = forwardRef((props, ref) => {
  const {
    isSelectedSection,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperIsSelectedSectionCss]: isSelectedSection
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");